import { makeAutoObservable } from 'mobx';
import RootStore from '../RootStore/RootStore';
import { ServerGridConfig } from '../../config/GridConfig';
import API_URL from '../../config/ApiUrl';
import axios from 'axios';
import { FileDetailType } from '../../config/Global';

export default class BulkFileAccommodationStore {
	list_data = null;
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	searchValue = '';

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			// called by the grid when more rows are required
			getRows: (params) => {
				// get data for request from server
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue
				);
				this.getList(payload)
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};

	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.FILEPROCESS.TEMPLE}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1&fileDetailType=${FileDetailType.Accommodation}`
			);
			return data.data;
		} catch {}
	};
}
